// src/ctxReflectorV2/components/Reporting/request/request.tsx
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "";

/**
 * Interface for Syslog Server request payload
 */
export interface SyslogServerRequest {
  ip: string;
  port: number;
  protocol: "udp" | "tcp";
  description: string;
}

/**
 * GET /api/v2/reflector/syslog-servers
 * Gets list of syslog servers.
 * @param token - Authentication token
 * @param tenantId - Tenant ID
 */
export function getSyslogServers(
  tenantId: number,
  token: string
) {
  const params = new URLSearchParams({
    tenantId: tenantId.toString()
  });
  return axios.get(`${API_URL}/v2/reflector/syslog-servers?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * GET /api/v2/reflector/syslog-servers/:id
 * Gets a single syslog server by ID.
 * @param token - Authentication token
 * @param serverId - Syslog server ID
 * @param tenantId - Tenant ID
 */
export function getSyslogServer(
  token: string,
  serverId: string | number,
  tenantId: number
) {
  const params = new URLSearchParams({
    tenantId: tenantId.toString()
  });
  return axios.get(`${API_URL}/v2/reflector/syslog-servers/${serverId}?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * POST /api/v2/reflector/syslog-servers
 * Creates a new syslog server.
 * @param token - Authentication token
 * @param tenantId - Tenant ID
 * @param data - Syslog server payload
 */
export function createSyslogServer(
  tenantId: number,
  token: string,
  data: SyslogServerRequest
) {
  const params = new URLSearchParams({
    tenantId: tenantId.toString()
  });
  return axios.post(`${API_URL}/v2/reflector/syslog-servers?${params.toString()}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * PUT /api/v2/reflector/syslog-servers/:id
 * Updates an existing syslog server.
 * @param token - Authentication token
 * @param serverId - Syslog server ID
 * @param tenantId - Tenant ID
 * @param data - Syslog server payload
 */
export function updateSyslogServer(
  token: string,
  serverId: string | number,
  tenantId: number,
  data: SyslogServerRequest
) {
  const params = new URLSearchParams({
    tenantId: tenantId.toString()
  });
  return axios.put(`${API_URL}/v2/reflector/syslog-servers/${serverId}?${params.toString()}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * DELETE /api/v2/reflector/syslog-servers/:id
 * Deletes a syslog server.
 * @param token - Authentication token
 * @param serverId - Syslog server ID
 * @param tenantId - Tenant ID
 */
export function deleteSyslogServer(
  token: string,
  serverId: string | number,
  tenantId: number
) {
  const params = new URLSearchParams({
    tenantId: tenantId.toString()
  });
  return axios.delete(`${API_URL}/v2/reflector/syslog-servers/${serverId}?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
